import { downloadAuthorizedFile, request } from './core.api';

export interface MaintenanceActivityDto {
  id: string;
  propertyId: string;
  activityDate: string;
  description: string;
  category: string;
  amount?: number;
  attachmentFileName?: string;
  attachmentContentType?: string;
  attachmentFileSizeBytes?: number;
  attachmentDownloadUrl?: string;
  createdAt: string;
}

export interface CreateMaintenanceActivityRequest {
  activityDate: string;
  description: string;
  category: string;
  amount?: number;
  attachmentFileName?: string;
  attachmentContentType?: string;
  attachmentFileSizeBytes?: number;
}

export interface CreateMaintenanceActivityResultDto {
  activity: MaintenanceActivityDto;
  attachmentUploadUrl?: string;
}

export const maintenanceActivitiesApi = {
  listByProperty: (propertyId: string) => request<MaintenanceActivityDto[]>(`/properties/${propertyId}/maintenance-activities`),
  create: (propertyId: string, data: CreateMaintenanceActivityRequest) =>
    request<CreateMaintenanceActivityResultDto>(`/properties/${propertyId}/maintenance-activities`, { method: 'POST', body: JSON.stringify(data) }),
  downloadAttachment: (id: string, fileName?: string) => downloadAuthorizedFile(`/maintenance-activities/${id}/attachment`, fileName),
  delete: (id: string) => request<void>(`/maintenance-activities/${id}`, { method: 'DELETE' }),
};
